export default __webpack_public_path__ + "static/media/Despoiler's Bracers of Ushering Twilight.a98dbc57.jpg";